import { render, staticRenderFns } from "./InfoPagesList.vue?vue&type=template&id=38563fc1"
import script from "./InfoPagesList.vue?vue&type=script&lang=js"
export * from "./InfoPagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports